import React from 'react';
import { ReactComponent as InformationIcon } from '../../assets/icons/information.svg';
import { format_price } from '../../js/utils';
import { AmountBadge } from '../AmountBadge';
import Tooltip from '../Tooltip';

import styles from './styles/cart_bonuses.module.scss';

export const CartBonuses = ({ amount }) => {
  const tooltipText =
    'Получение бонусов-рублей за покупки доступно только для зарегистрированных пользователей';

  return (
    <div className={styles.cart_bonuses}>
      <span className={styles.cart_bonuses__text}>Будет начислено</span>
      <Tooltip toolTipMessage={tooltipText}>{<InformationIcon />}</Tooltip>
      <AmountBadge
        classes={styles.cart_bonuses__badge}
        type="cart"
        amount={`+${format_price(amount)}`}
        currency="₽"
      />
    </div>
  );
};
